import React from "react"
import { graphql } from "gatsby"
import CommonTemplate from "templates/common-template"
import WhatsNewPost from "templates/pages/whats-new-post"

// markup
const IndexPage = ({ location, data }) => {
    const { pageData, post } = data
    const { category } = pageData

    // const pageData = page
    const modifiedData = {
        pageData: { ...pageData, ...category },
    }

    const breadcrumbTitle = category.subtitle || category.name
    const breadcrumb = [breadcrumbTitle, "Promotions", post.title]

    const arrData = {
        location,
        data: modifiedData,
        bgColor:
            "linear-gradient(90deg, #b4e5ff 25%, #bde8ff 25%, #bde8ff 50%, #b4e5ff 50%, #b4e5ff 75%, #bde8ff 75%, #bde8ff 100%)",
        // galleryMinWidth: "40%", //default 0
        customElement: <WhatsNewPost data={data} />,
        onlyCustom: "partial",
        parentLink: "whats-new/promotions",
        breadcrums: breadcrumb, // allow null
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query PromotionsPostQuery($slug: String!) {
        pageData: strapiPage(
            slug: { eq: "eip-promotions" }
            company: { shortname: { eq: "EIP" } }
        ) {
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
        }
        post: strapiPost(slug: { eq: $slug }, Post_Type: { eq: "Promotions" }) {
            title
            summary
            description
            published_at
            category {
                name
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            services {
                name
                slug
            }
            events: Content {
                Event_Data {
                    enddate
                    startdate
                    Type
                }
                Call_To_Action {
                    buttonLink
                    buttonText
                    buttonType
                    id
                }
            }
            image {
                publicURL
                childImageSharp {
                    gatsbyImageData(
                        placeholder: BLURRED
                        width: 720
                        height: 560
                    )
                }
            }
            content: additional_content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                Multi_Columns {
                    Text_Alignment
                    content
                    id
                    title
                }
                Text_With_Image {
                    Layout_Type
                    content
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                            original {
                                width
                            }
                        }
                    }
                }
            }
        }
    }
`
